module.exports = __webpack_public_path__ + "static/img/wow2.7cbd06ed.png";